import React from 'react'

import styled from 'styled-components'

export interface RowStyles {
  justifyContent?: React.CSSProperties['justifyContent']
  alignItems?: React.CSSProperties['alignItems']
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  gap?: string
  flexWrap?: React.CSSProperties['flexWrap']
}

export const CustomRow = styled.div<RowStyles>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ gap }) => gap};
  align-items: ${({ alignItems }) => alignItems};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  flex-wrap: ${({ flexWrap }) => flexWrap};
`
